module.exports = __webpack_public_path__ + "img/pxflux-player-icon-v5-128px.be5bb0c8.png";